import type { JSX } from "react";
import type { ActivePrompt } from "../../services/prompt/prompt-service";
import { Dialog, css, styled } from "@mui/material";
import { useObservable } from "ecce-react";
import { useLatch } from "../../util/use-latch";
import { useServices } from "../../services/services-context";


const PromptDialogRoot = styled(Dialog)(({ theme }) => css`
	.MuiDialog-paper {
		max-width: 100vw;
		max-height: 100vh;
		margin: unset;
		border-radius: 0;
		
		${theme.breakpoints.up("sm")} {
			border-radius: ${theme.shape.borderRadius}px;
		}
	}
`);

type PromptDialogProps = {
	activePrompt: ActivePrompt;
};
const PromptDialog = ({ activePrompt }: PromptDialogProps): JSX.Element | null => {
	useObservable(activePrompt, "prompt");
	const promptToShow = useLatch(activePrompt.prompt);

	if(!promptToShow) {
		return null;
	}

	return (
		<PromptDialogRoot open={ !!activePrompt.prompt } maxWidth={ false }>
			{ promptToShow.view() }
		</PromptDialogRoot>
	);
};

export const PromptDialogs = (): JSX.Element | null => {
	const service = useServices().prompt;
	useObservable(service.activePrompts);

	const prompts = service.activePrompts.map(activePrompt => (
		<PromptDialog activePrompt={ activePrompt } key={ activePrompt.id }/>
	));

	if(!prompts.length) {
		return null;
	}

	return <>{ prompts }</>;
};
